var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*
    This file is generated with the "identicons" script.
    To update this output make changes to `scripts/svgr/identicon-icon-template.js
    */
import * as React from 'react';
import { IdenticonsCustomProperty, useColorMap, identiconComponentName } from '../common';
import { styled } from '../../styled';
export var IdenticonAttributes = styled(function (_a) {
    var color = _a.color, props = __rest(_a, ["color"]);
    var colorMap = useColorMap({
        color: color,
    });
    var fills = {
        light: "var(".concat(IdenticonsCustomProperty.light, ", ").concat(colorMap.light, ")"),
        base: "var(".concat(IdenticonsCustomProperty.base, ", ").concat(colorMap.base, ")"),
        dark: "var(".concat(IdenticonsCustomProperty.dark, ", ").concat(colorMap.dark, ")"),
    };
    return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M37.954 14.174V40a3.992 3.992 0 01-3.992 3.992h-19.97A3.992 3.992 0 0110 40V8.018a3.992 3.992 0 013.992-3.992h13.986l9.976 10.148z", fill: fills.light }),
        React.createElement("path", { d: "M37.97 14.11H31.22a3.3 3.3 0 01-3.3-3.3V4L37.97 14.11z", fill: fills.dark }),
        React.createElement("path", { d: "M29.986 22H18.014A2.007 2.007 0 0016 24c0 1.103.9 2 2.014 2h11.972A2.007 2.007 0 0032 24c0-1.106-.9-2-2.014-2zM26.1 28h-8.2c-1.048 0-1.9.894-1.9 2 0 1.103.85 2 1.9 2h8.2c1.048 0 1.9-.894 1.9-2 0-1.106-.852-2-1.9-2z", fill: fills.base })));
}, {
    name: identiconComponentName,
})({});
